export default __webpack_public_path__ + "static/media/uniqshow.fd30b572.svg";